export default "__VITE_ASSET__DZlwhQ$c__"